import React from 'react';
import { formatDate } from '../../Tasks/taskFactory';
import type { NutritionProductLine } from './computeNutritionAudit';

/**
 * When a product goes on — its own date, or its task's — in the same format
 * as the Tasks grid (a month-only task date shows the month). A dash when
 * neither is set.
 */
const ProductDate: React.FC<{ line: NutritionProductLine }> = ({ line }) => {
  const text = line.date ? formatDate(line.date, line.dateHasDay).trim() : '';
  return text ? (
    <span className="whitespace-nowrap">{text}</span>
  ) : (
    <span className="text-gray-muted">—</span>
  );
};

export default ProductDate;
